import React from 'react'
import Section from './Section'
import Hero from './section/Hero'
import Features from './section/Features'
import Preview from './section/Preview'
import Products from './section/Products'
//import EarlyAccess from './section/EarlyAccess'

export default class Main extends React.Component {
  state={}
  render() {
    return (
      <main>
        <Hero />
        <Features />
        <Section>
          <Preview />
          <Products />
        </Section>
      </main>
    )
  }
}



// WEBPACK FOOTER //
// ./src/component/Main.js